import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';

import {ApiModule} from '@spa/api';

import {ReportingModule} from '@spa/reporting';

import flagsmith from '@flagsmith/flagsmith';

import {AuthGuardService, CurrencyService, FLAGSMITH_CLIENT} from './shared/services';
import {CacheInterceptor, AuthInterceptor, GlobalErrorHandler, FEATURE_FLAGS_INITIALIZER} from './shared/providers';
import {FlagsmithClientInterface} from './shared/interfaces';

import {AppRoutingModule} from './app-routing.module';

import {AppComponent} from './app.component';

import {environment} from 'appEnv/environment';
import { CommonModule } from '@angular/common';

const flagsmithClient: FlagsmithClientInterface = flagsmith;

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,

        ApiModule.forRoot({
            authUrl: environment.authUrl,
            authId: environment.authId,
            authRedirectUrl: environment.authRedirectUrl,
            authScopes: environment.authScopes,
            authRandomGeneratedAwaitLoginKey: environment.randomGeneratedAwaitLoginKey,
            authClientStorageKey: environment.authClientStorageKey,
            customCacheResponseHeader: environment.customCacheResponseHeader,
            customProtectedApiHeader: environment.customProtectedApiHeader,
            crmApiUrl: environment.crmApiUrl,
            crmBaseApiUrl: environment.crmBaseApiUrl,
            sesApiUrl: environment.sesApiUrl,
            amsApiUrl: environment.amsApiUrl,
            filesApiUrl: environment.filesApiUrl,
            reportingNetBaseApiUrl: environment.reportingNetBaseApiUrl,
            fundOrdersApiUrl: environment.fundOrdersApiUrl,
            auditApiUrl: environment.auditApiUrl,
            fundamentalApiUrl: environment.fundamentalApiUrl,
            closeOutApiUrl: environment.closeOutApiUrl,
            supportSystemApiUrl: '',
            payGatewayUrl: environment.payGatewayUrl,
            authEnableAutomaticSilentRenew: environment.authEnableAutomaticSilentRenew,
            authDisableSessionMonitoring: environment.authDisableSessionMonitoring
        }),

        ReportingModule.forRoot({
            apiUrl: environment.reportingNetBaseApiUrl,
            customProtectedApiHeader: environment.customProtectedApiHeader
        })
    ],
    declarations: [
        AppComponent
    ],
    bootstrap: [
        AppComponent
    ],
    providers: [
        AuthGuardService,
        CurrencyService,

        {
            provide: HTTP_INTERCEPTORS,
            useClass: CacheInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        },
        {
            provide: FLAGSMITH_CLIENT,
            useValue: flagsmithClient
        },
        FEATURE_FLAGS_INITIALIZER
    ]
})
export class AppModule {
}
